import { render, staticRenderFns } from "./EmailSenderList.vue?vue&type=template&id=65f3199a"
import script from "./EmailSenderList.vue?vue&type=script&lang=js"
export * from "./EmailSenderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports